import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_13: FaireProductEntity = {
  token: "toysmith-13",
  type: "product",
  name: "Deluxe Zen Garden, Stress Relief, Desktop Toy",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/1da1d9a6d34901652a6ce55458d5717718559b7455a3bcccca883fec4fecf899.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=913,914,x0,y43,safe&width=720",
  priceDollars: 10,
  msrpDollars: 20,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
